module.exports = __webpack_public_path__ + "static/media/visa.ca07b459.svg";